import script from "./FormulasButton.vue?vue&type=script&setup=true&lang=js"
export * from "./FormulasButton.vue?vue&type=script&setup=true&lang=js"

import "./FormulasButton.vue?vue&type=style&index=0&id=7961a76b&lang=scss"

const __exports__ = script;

export default __exports__